(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  var clipboard = new ClipboardJS('.product__banner');
  clipboard.on('success',function(e){
    theme.tip(e.text)
  })
  var PIC_DOMAIN = 'https://pic.wanwustore.cn/'
  
  var isPc = theme.isPc

  var PC_SIZE_MAP = {
    baby_cm: PIC_DOMAIN + 'baby （cm).png',
    baby_inch: PIC_DOMAIN + 'baby （inches).png',
    kids_cm: PIC_DOMAIN + 'kids（cm）.png',
    kids_inch: PIC_DOMAIN + 'kids（inches）.png',
    shoes_cm: PIC_DOMAIN + 'shoes_cm.png',
    shoes_inch: PIC_DOMAIN + 'shoes_inches.png',
    toddler_cm: PIC_DOMAIN + 'toddler(cm).png',
    toddler_inch: PIC_DOMAIN + 'toddler(inches).png'
  }
  var MB_SIZE_MAP={
    baby_cm: PIC_DOMAIN + 'baby （cm)Mob.png',
    baby_inch: PIC_DOMAIN + 'baby （inches)Mob.png',
    kids_cm: PIC_DOMAIN + 'kids（cm）Mob.png',
    kids_inch: PIC_DOMAIN + 'kids（inches）Mob.png',
    shoes_cm: PIC_DOMAIN + 'shoes(cm)Mob.png',
    shoes_inch: PIC_DOMAIN + 'shoes(inches)Mob.png',
    toddler_cm: PIC_DOMAIN + 'toddler(cm)Mob.png',
    toddler_inch: PIC_DOMAIN + 'toddler(inches)Mob.png'
  }

  var MAP = isPc?PC_SIZE_MAP:MB_SIZE_MAP
  for(let key in MAP){
    let img= new Image()
      img.src = MAP[key]
  }
  var mapKey = 'baby_inch'

  $('.size__guide').click(function () {
    $('.ww__modal').show()
  })
  $('.ww__modal').click(function () {
    $('.ww__modal').hide()
  })
  $('.size__panel').click(function (e) {
    e.stopPropagation()
    var data = e.target.dataset
    if (!data) return
    var type = data.type,
      val = data.val
    if(!type || !val) return
    change(type, val)
  })
  function change(type, val) {
    console.log(MAP,MAP[key])
    $('[data-type=' + type + ']').removeClass('focus')
    $('[data-type=' + type + '][data-val=' + val + ']').addClass('focus')
    let cate = $('.tab__ele.focus').attr('data-val')
    let unit = $('.unit__ele.focus').attr('data-val')
    var key = cate + '_' + unit
    var img = MAP[key]
    $('.size__img').attr('src', img)
  }
  $('.size__img').attr('src', MAP[mapKey])

  } catch(e) { console.error(e); }
})();
      })();
